export default __webpack_public_path__ + "static/media/img8.f191d389.png";